// Copyright (c) 2016 Deere & Company

import busyCounter from '../../../shared/reducers/busy-counter';
import {combineReducers} from 'redux';
import criteria from './criteria';
import formatting from './formatting';
import isCriteriaValid from '../../shared/reducers/is-criteria-valid';
import planNames from './plan-names';
import report from './report';
import reportIsScrollable from '../../shared/reducers/report-is-scrollable';
import serviceIntervalTypes from './service-interval-types';
import showNoResultsFound from '../../shared/reducers/show-no-results-found';
import views from './views';

export const getCombinedReducers = () =>
    combineReducers({
        busyCounter,
        criteria,
        formatting,
        isCriteriaValid,
        planNames,
        report,
        reportIsScrollable,
        serviceIntervalTypes,
        showNoResultsFound,
        views
    });



// WEBPACK FOOTER //
// ./src/reports/maintenance-plan/reducers/index.js